<template>
  <v-data-table
    :headers="installationAcceptanceItemDataTableHeaders"
    :items="computedAcceptanceItems"
    class="elevation-1 my-5 mx-5"
    :search="searchInstallationAcceptanceItems"
    :loading-text="$t('common_get_data')"
    :no-data-text="$t('common_no_data')"
    :no-results-text="$t('common_no_results')"
    :footer-props="{
      'items-per-page-options': [30, 50, 100],
      'items-per-page-text': $t('item_rows_per_page'),
    }"
    :header-props="headerProps"
    item-key="Index"
    show-select
    v-model="selectNeedThrowItem"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t(titleName) }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchInstallationAcceptanceItems"
          append-icon="mdi-magnify"
          :label="$t('quotation_item_new_install_search')"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <v-btn
          color="primary"
          dark
          class="mb-2 ml-8"
          :disabled="isAllTextFieldDisable || !isDone || isAcceptance"
          @click="setItemIsNeedThrowResume"
        >
          確定拋轉的品項
        </v-btn>
        <v-dialog v-model="isShowEditInstallationAcceptanceItemDialog" persistent fullscreen>
          <!-- <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2 ml-8"
              v-bind="attrs"
              v-on="on"
              :disabled="isAllTextFieldDisable || !isDone || isAcceptance"
            >
              {{ $t('quotation_item_new_install_new_item_btn') }}
            </v-btn>
          </template> -->
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ installationAcceptanceItemDialogTitle }}</span>
              <v-spacer></v-spacer>
            </v-card-title>

            <v-card-text>
              <v-container>
                <ValidationObserver ref="dialogEditedInstallationAcceptanceItem">
                  <v-row>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-checkbox
                        v-model="editedAcceptanceItem.IsCustomerDevice"
                        :label="$t('quotation_item_is_customer_device')"
                        required
                        :disabled="isAcceptance"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-autocomplete
                        v-model="editedAcceptanceItem.CustomerDeviceType"
                        :items="customerDeviceTypeList"
                        item-text="Name"
                        item-value="Type"
                        :label="$t('engineer_item_customer_device_type')"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        v-if="editedAcceptanceItem.IsCustomerDevice"
                        :disabled="isAcceptance"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-autocomplete
                        :items="bomList"
                        item-text="Name"
                        item-value="Id"
                        return-object
                        v-model="editedAcceptanceItem.BomId"
                        @change="setEditedAcceptanceBomId"
                        :disabled="isAcceptance"
                        label="Bom名稱"
                      >
                        <template v-slot:item="data">
                          <template>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ data.item.Name }}
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                {{ data.item.Describe }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-text-field
                        v-model="editedAcceptanceItem.BomDescribe"
                        label="Bom描述"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-checkbox
                        v-model="editedAcceptanceItem.IsNeedThrowResume"
                        label="確定轉拋履歷卡"
                        :disabled="isAcceptance"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <resume-item-filter-all-type-autocomplete
                        :fatherEditedItem="editedAcceptanceItem"
                        :editedItemIndex="editedAcceptanceItemIndex"
                        :itemName="'quotation_item_number'"
                        :customerDeviceType="editedAcceptanceItem.CustomerDeviceType"
                        @setEditedItem="setEditedItem"
                        :isAllTextFieldDisable="isAllTextFieldDisable"
                        v-if="
                          editedAcceptanceItemIndex === -1 &&
                            isShowEditInstallationAcceptanceItemDialog
                        "
                        refName="itemAutocomplete"
                        @keyupEnter="focusNextInput"
                      />
                      <ValidationProvider
                        :name="$t('quotation_item_number')"
                        rules="required"
                        v-slot="{ errors }"
                        v-else
                      >
                        <v-text-field
                          v-model="editedAcceptanceItem.Number"
                          :label="$t('quotation_item_number')"
                          disabled
                          :error-messages="errors[0]"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('quotation_item_name')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedAcceptanceItem.Name"
                          :label="$t('quotation_item_name')"
                          disabled
                          :error-messages="errors[0]"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('quotation_item_unit')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedAcceptanceItem.Unit"
                          :label="$t('quotation_item_unit')"
                          required
                          disabled
                          :error-messages="errors[0]"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('quotation_item_quantity')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedAcceptanceItem.Quantity"
                          :label="$t('quotation_item_quantity')"
                          required
                          clearable
                          :disabled="editedAcceptanceItemIndex !== -1 || isAcceptance"
                          :error-messages="errors[0]"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('installation_acceptance_item_real_quantity')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedAcceptanceItem.RealQuantity"
                          :label="$t('installation_acceptance_item_real_quantity')"
                          required
                          clearable
                          :disabled="isAcceptance"
                          :error-messages="errors[0]"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="3"
                      md="3"
                      xl="3"
                      lg="3"
                      v-if="
                        editedAcceptanceItem.HasSerialNumber &&
                          (!editedAcceptanceItem.IsCustomerDevice ||
                            (editedAcceptanceItem.IsCustomerDevice &&
                              editedAcceptanceItem.CustomerDeviceType === 3))
                      "
                    >
                      <v-autocomplete
                        v-model="editedAcceptanceItem.SerialNumber"
                        :items="throwResumeList"
                        item-text="Number"
                        item-value="Number"
                        :label="$t('quotation_item_serialnumber')"
                        required
                        :disabled="!editedAcceptanceItem.HasSerialNumber"
                        return-object
                        small-chips
                        multiple
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        v-if="editedAcceptanceItemIndex === -1"
                        @focus="getItemSerialNumber"
                      >
                      </v-autocomplete>
                      <v-text-field
                        v-model="editedAcceptanceItem.SerialNumber.Number"
                        :label="$t('quotation_item_serialnumber')"
                        disabled
                        v-else
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-autocomplete
                        v-model="editedAcceptanceItem.InstallPosition"
                        :items="allInstallPositionType"
                        item-text="Name"
                        item-value="Type"
                        :label="$t('quotation_item_install_position')"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        :disabled="isAcceptance"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ValidationProvider
                        :name="$t('installation_acceptance_item_reason')"
                        rules="required"
                        v-slot="{ errors }"
                        v-if="
                          editedAcceptanceItem.Quantity * 1 !==
                            editedAcceptanceItem.RealQuantity * 1
                        "
                      >
                        <v-textarea
                          outlined
                          v-model="editedAcceptanceItem.Reason"
                          :label="$t('installation_acceptance_item_reason')"
                          :error-messages="errors[0]"
                          :disabled="isAcceptance"
                        ></v-textarea>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('quotation_item_warranty_period')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedAcceptanceItem.WarrantyPeriod"
                          required
                          clearable
                          :error-messages="errors[0]"
                          :disabled="editedAcceptanceItemIndex !== -1 && isAcceptance"
                          @keyup.enter="focusNextInput"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('quotation_item_warranty_period') }}
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('installation_notice_item_buy_or_rent')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-autocomplete
                          v-model="editedAcceptanceItem.BuyOrRentType"
                          :items="allBuyOrRentType"
                          item-text="Name"
                          item-value="Type"
                          :disabled="isAcceptance"
                          required
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_results')"
                          :error-messages="errors[0]"
                          @change="setBuyOrRentType"
                          @keyup.enter="setBuyOrRentTypeAutocomplete"
                          ref="buyOrRentTypeAutocomplete"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('installation_notice_item_buy_or_rent') }}
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <v-autocomplete
                        v-model="editedAcceptanceItem.Custody"
                        :items="allCustodyType"
                        item-text="Name"
                        item-value="Type"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        :disabled="isAcceptance"
                        :label="$t('resume_item_custody')"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedAcceptanceItem.HasAuthorize">
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-autocomplete
                        :items="gmTypeList"
                        item-text="Name"
                        item-value="Type"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        v-model="editedAcceptanceItem.GmServerType"
                        label="GM"
                        :disabled="isAcceptance"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-text-field
                        v-model="editedAcceptanceItem.AuthorizeItemSerialNumber"
                        label="授權序號"
                        :disabled="isAcceptance"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedAcceptanceItem.Reason">
                    <v-col>
                      <ValidationProvider
                        :name="$t('installation_acceptance_item_reason')"
                        rules="required"
                        v-slot="{ errors }"
                        v-if="
                          editedAcceptanceItem.Quantity * 1 !==
                            editedAcceptanceItem.RealQuantity * 1
                        "
                      >
                        <v-textarea
                          outlined
                          v-model="editedAcceptanceItem.Reason"
                          :error-messages="errors[0]"
                          :disabled="isAcceptance"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('installation_acceptance_item_reason') }}
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                      <ValidationProvider
                        name="換GM Server原因"
                        rules="required"
                        v-slot="{ errors }"
                        v-else
                      >
                        <v-textarea
                          outlined
                          v-model="editedAcceptanceItem.Reason"
                          :error-messages="errors[0]"
                          :disabled="isAcceptance"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            換GM Server原因
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </ValidationObserver>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeEditAcceptanceItem">
                {{ $t('common_cancel') }}
              </v-btn>
              <v-btn color="green darken-1" text @click="addAcceptanceItem">
                {{ $t('common_confirm') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <delete-dialog
          :isAllTextFieldDisable="false"
          :isLoadingSaveBtn="false"
          :isShowDeleteDialog="isShowDeleteInstallationAcceptanceItemDialog"
          :deleteMessage="'installation_acceptance_item_delete_dialog_message'"
          @closeDelete="closeDeleteAcceptanceItem"
          @confirmDelete="confirmDeleteAcceptanceItem"
        />
      </v-toolbar>
    </template>
    <template v-slot:[`header.data-table-select`] v-if="isAcceptance"></template>
    <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
      <v-simple-checkbox
        :ripple="false"
        :value="isSelected"
        :readonly="isAcceptance"
        :disabled="isAcceptance"
        @input="select($event)"
      ></v-simple-checkbox>
    </template>
    <template v-slot:[`item.Edit`]="{ item }">
      <v-btn
        icon
        @click="isShowEditInstallationAcceptanceItemDialogBtn(item)"
        :disabled="isAllTextFieldDisable || !isDone || isAcceptance"
      >
        <v-icon small>
          mdi-pencil
        </v-icon>
      </v-btn>
      <v-btn
        icon
        @click="isShowDeleteAcceptanceItemDialogBtn(item)"
        :disabled="isAllTextFieldDisable || !isDone || isAcceptance"
      >
        <v-icon small>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:[`item.InstallPosition`]="{ item }">
      {{ turnData(item.InstallPosition) }}
    </template>
    <template v-slot:[`item.BuyOrRentType`]="{ item }">
      {{ turnBuyOrRentType(item.BuyOrRentType) }}
    </template>
    <template v-slot:[`item.IsInQuotation`]="{ item }">
      <p v-if="!item.IsInQuotation" style="color: darkred;">*</p>
    </template>
    <template v-slot:[`header.IsInQuotation`]="{}">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="error" dark v-bind="attrs" v-on="on">
            mdi-information
          </v-icon>
        </template>
        <span>* 不在報價單</span>
      </v-tooltip>
    </template>
    <template v-slot:[`item.Custody`]="{ item }">
      {{ turnCustodyData(item.Custody) }}
    </template>
  </v-data-table>
</template>

<script>
import { BuyOrRentType } from '@/js/BuyOrRentType'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import {
  HttpInstallationAcceptance,
  HttpInstallPosition,
  HttpSerialNumber,
  HttpQuotation,
  HttpFix,
  HttpAuthorizeMapping,
  HttpBom
} from '@/js/http-Manager'
import ResumeItemFilterAllTypeAutocomplete from '@/components/ResumeItemFilterAllTypeAutocomplete.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { CustodyType } from '@/js/CustodyType'
export default {
  name: 'AcceptanceItemNotInResume',
  components: { DeleteDialog, ResumeItemFilterAllTypeAutocomplete },
  props: {
    acceptanceItems: {
      type: Array,
      default () {
        return []
      }
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    isAcceptance: {
      type: Boolean,
      default: false
    },
    isDone: {
      type: Boolean,
      default: false
    },
    titleName: {
      type: String
    }
  },
  data: () => ({
    gmTypeList: [],
    searchInstallationAcceptanceItems: '',
    isShowEditInstallationAcceptanceItemDialog: false,
    isShowDeleteInstallationAcceptanceItemDialog: false,
    editedAcceptanceItemIndex: -1,
    bomList: [],
    editedAcceptanceItem: {
      ItemId: '',
      Number: '',
      Name: '',
      Unit: '',
      Quantity: 0,
      RealQuantity: 0,
      BuyOrRentType: 0,
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      WarrantyPeriod: 0,
      IsCustomerDevice: false,
      CustomerDeviceType: 0,
      InstallPosition: 0,
      HasSerialNumber: false,
      Reason: '',
      Custody: 0
    },
    defaultAcceptanceItem: {
      ItemId: '',
      Number: '',
      Name: '',
      Unit: '',
      Quantity: 0,
      RealQuantity: 0,
      BuyOrRentType: 0,
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      WarrantyPeriod: 0,
      IsCustomerDevice: false,
      CustomerDeviceType: 0,
      InstallPosition: 0,
      HasSerialNumber: false,
      Reason: '',
      Custody: 0
    },
    allBuyOrRentType: [],
    allInstallPositionType: [],
    itemSerialNumberList: [],
    customerDeviceTypeList: [],
    allCustodyType: [],
    selectNeedThrowItem: []
  }),
  async mounted () {
    await this.getAllBoms()
    await this.getBuyOrRentType()
    await this.getAllInstallPositionType()
    await this.getCustomerDeviceType()
    await this.getAllCustodyType()
    await this.getGmTypeList()
    if (this.acceptanceItems.length > 0) {
      this.selectNeedThrowItem = this.computedAcceptanceItems.filter((x) => x.IsNeedThrowResume)
    }
  },
  watch: {
    acceptanceItems (val) {
      if (val.length > 0) {
        this.selectNeedThrowItem = this.computedAcceptanceItems.filter((x) => x.IsNeedThrowResume)
      }
    }
  },
  computed: {
    computedAcceptanceItems () {
      let array = []
      this.acceptanceItems.forEach((element, index) => {
        array.push(
          Object.assign(
            {
              Index: index
            },
            element
          )
        )
      })
      return array
    },
    throwResumeList () {
      var tt = []
      this.itemSerialNumberList.forEach((element) => {
        if (!element.IsUsed) {
          tt.push(element)
        }
      })
      return tt
    },
    installationAcceptanceItemDialogTitle () {
      return this.editedAcceptanceItemIndex === -1
        ? this.$t('installation_acceptance_item_add')
        : this.$t('installation_acceptance_item_edit')
    },
    installationAcceptanceItemDataTableHeaders () {
      return [
        { text: '', align: 'start', value: 'IsInQuotation', width: '5', sortable: false },
        { text: this.$t('installation_notice_item_main_name'), align: 'start', value: 'BomName' },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_quantity'), align: 'end', value: 'Quantity' },
        {
          text: this.$t('installation_acceptance_item_real_quantity'),
          align: 'end',
          value: 'RealQuantity'
        },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'start',
          value: 'BuyOrRentType'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber.Number'
        },
        { text: this.$t('quotation_item_warranty_period'), align: 'end', value: 'WarrantyPeriod' },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'IsCustomerDevice'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPosition'
        },
        {
          text: this.$t('resume_item_custody'),
          align: 'start',
          value: 'Custody'
        },
        {
          text: '要拋轉?',
          align: 'start',
          value: 'IsNeedThrowResume',
          sortable: false
        },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  methods: {
    setEditedAcceptanceBomId () {
      this.editedAcceptanceItem.BomName = this.editedAcceptanceItem.BomId.Name
      this.editedAcceptanceItem.BomDescribe = this.editedAcceptanceItem.BomId.Describe
      this.editedAcceptanceItem.BomId = this.editedAcceptanceItem.BomId.Id
      this.editedAcceptanceItem = JSON.parse(JSON.stringify(this.editedAcceptanceItem))
    },
    async getAllBoms () {
      let response = await HttpBom.GetAllBoms()
      this.bomList = response && response.status === 200 ? response.data.Data : []
    },
    async getGmTypeList () {
      let response = await HttpAuthorizeMapping.GetGmTypes()
      this.gmTypeList = response.status === 200 ? response.data.Data : []
    },
    setItemIsNeedThrowResume () {
      let temp = this.computedAcceptanceItems
      this.selectNeedThrowItem.forEach((element) => {
        let index = temp.indexOf(element)
        temp.splice(index, 1)
      })
      this.$emit('setItemIsNeedThrowResume', temp)
      this.selectNeedThrowItem = []
    },
    setBuyOrRentTypeAutocomplete (event) {
      this.$refs.buyOrRentTypeAutocomplete.isMenuActive = false
      this.$refs.buyOrRentTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    turnCustodyData (val) {
      return CustodyType.CustodyTypeName(val)
    },
    async getAllCustodyType () {
      let response = await HttpFix.GetCustodyType()
      this.allCustodyType = response.status === 200 ? response.data.Data : []
    },
    async getCustomerDeviceType () {
      let response = await HttpQuotation.GetCustomerDeviceType()
      this.customerDeviceTypeList = response.status === 200 ? response.data.Data : 0
    },
    setEditedItem (val) {
      this.editedAcceptanceItem.ItemId = val.Id
      this.editedAcceptanceItem.Number = val.Number
      this.editedAcceptanceItem.Name = val.Name
      this.editedAcceptanceItem.Unit = val.Unit
      this.editedAcceptanceItem.Price = val.Price
      this.editedAcceptanceItem.IsMonthItem = val.IsMonthItem
      this.editedAcceptanceItem.IsDelete = val.IsDelete
      this.editedAcceptanceItem.StoreNo = val.StoreNo
      this.editedAcceptanceItem.RepairPrice = val.RepairPrice
      this.editedAcceptanceItem.RepairWarrantyPeriod = val.RepairWarrantyPeriod
      this.editedAcceptanceItem.RentWarrantyPeriod = val.RentWarrantyPeriod
      this.editedAcceptanceItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedAcceptanceItem.IsCustomerDevice = val.IsCustomerDevice
      this.editedAcceptanceItem.HasSerialNumber = val.HasSerialNumber
      this.editedAcceptanceItem = JSON.parse(JSON.stringify(this.editedAcceptanceItem))
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    setBuyOrRentType () {
      let tempEdited = JSON.parse(JSON.stringify(this.editedAcceptanceItem))
      this.editedAcceptanceItem.BuyOrRentType = tempEdited.BuyOrRentType
    },
    async getItemSerialNumber () {
      let param = {
        itemId: this.editedAcceptanceItem.ItemId
      }
      let response = await HttpSerialNumber.GetSerialNumberFromItemId(param)
      this.itemSerialNumberList = response.status === 200 ? response.data.Data : []
    },
    turnData (value) {
      if (value) {
        return ItemInstallPositionType.getFormInstallPositionTypeName(
          value,
          this.allInstallPositionType
        )
      }
    },
    async getAllInstallPositionType () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionType = response.status === 200 ? response.data.Data : []
    },
    async getBuyOrRentType () {
      let response = await HttpInstallationAcceptance.GetBuyOrRentTypes()
      this.allBuyOrRentType = response.status === 200 ? response.data.Data : []
    },
    isShowEditInstallationAcceptanceItemDialogBtn (item) {
      this.editedAcceptanceItemIndex = this.computedAcceptanceItems.indexOf(item)
      let str = JSON.stringify(item)
      this.editedAcceptanceItem = JSON.parse(str)
      this.isShowEditInstallationAcceptanceItemDialog = true
    },

    isShowDeleteAcceptanceItemDialogBtn (item) {
      this.editedAcceptanceItemIndex = this.computedAcceptanceItems.indexOf(item)
      let str = JSON.stringify(item)
      this.editedAcceptanceItem = JSON.parse(str)
      this.isShowDeleteInstallationAcceptanceItemDialog = true
    },

    confirmDeleteAcceptanceItem () {
      this.$emit('setDeleteItem', this.editedAcceptanceItemIndex)
      this.closeDeleteAcceptanceItem()
    },

    closeEditAcceptanceItem () {
      this.isShowEditInstallationAcceptanceItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultAcceptanceItem)
        this.editedAcceptanceItem = JSON.parse(str)
        this.editedAcceptanceItemIndex = -1
      })
    },

    closeDeleteAcceptanceItem () {
      this.isShowDeleteInstallationAcceptanceItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultAcceptanceItem)
        this.editedAcceptanceItem = JSON.parse(str)
        this.editedAcceptanceItemIndex = -1
      })
    },
    async addAcceptanceItem () {
      const isValid = await this.$refs.dialogEditedInstallationAcceptanceItem.validate()
      if (isValid) {
        this.$emit('setEditedAcceptanceItemIndex', this.editedAcceptanceItemIndex)
        this.$emit('setEditedAcceptanceItem', this.editedAcceptanceItem)

        this.closeEditAcceptanceItem()
      }
    }
  }
}
</script>
